"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _SortArrows = _interopRequireDefault(require("../SortArrows"));

var _Datatable = _interopRequireDefault(require("../Datatable.css"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Datatable["default"]);

var TableHeader = /*#__PURE__*/function (_Component) {
  _inherits(TableHeader, _Component);

  var _super = _createSuper(TableHeader);

  function TableHeader(props) {
    var _this;

    _classCallCheck(this, TableHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getHeaderDisplayName", function (header) {
      var customColumnDisplayName = _this.props.customColumnDisplayName;
      return header in customColumnDisplayName ? customColumnDisplayName[header] : header;
    });

    _defineProperty(_assertThisInitialized(_this), "activateHover", function (header) {
      _this.setState({
        isHovering: header
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deactivateHover", function () {
      _this.setState({
        isHovering: null
      });
    });

    _this.state = {
      isHovering: null
    };
    return _this;
  }

  _createClass(TableHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          headers = _this$props.headers,
          sortableColumns = _this$props.sortableColumns,
          handleSort = _this$props.handleSort,
          isLoading = _this$props.isLoading,
          currentSort = _this$props.currentSort,
          shouldFreezeActions = _this$props.shouldFreezeActions,
          isCompactMode = _this$props.isCompactMode,
          isNotSelectable = _this$props.isNotSelectable,
          hasRowActions = _this$props.hasRowActions,
          rightAlignedColumns = _this$props.rightAlignedColumns;
      var isHovering = this.state.isHovering;
      return /*#__PURE__*/_react["default"].createElement("tr", null, !isNotSelectable && /*#__PURE__*/_react["default"].createElement("th", {
        className: cx('checkbox--spacer')
      }), headers.map(function (h) {
        var style = {};

        if (rightAlignedColumns.includes(h)) {
          style.justifyContent = 'flex-end';
        }

        return /*#__PURE__*/_react["default"].createElement("th", {
          className: "sortable-column header-".concat(h.replace(' ', '_')),
          key: "header-".concat(h),
          onClick: function onClick() {
            return sortableColumns.includes(h) && handleSort(h);
          },
          onMouseEnter: function onMouseEnter() {
            return _this2.activateHover(h);
          },
          onMouseLeave: function onMouseLeave() {
            return _this2.deactivateHover();
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: cx('table-head'),
          style: style
        }, _this2.getHeaderDisplayName(h), sortableColumns.includes(h) && /*#__PURE__*/_react["default"].createElement(_SortArrows["default"], {
          columnName: _this2.getHeaderDisplayName(h),
          isHoveringColumn: isHovering === h,
          isSortDownActive: currentSort && currentSort.field === h && currentSort.direction === _constants.SORT_DIRECTION_DESC,
          isSortUpActive: currentSort && currentSort.field === h && currentSort.direction === _constants.SORT_DIRECTION_ASC
        })));
      }), !isLoading && hasRowActions && /*#__PURE__*/_react["default"].createElement("th", {
        className: cx({
          "static": shouldFreezeActions,
          'freeze-right': shouldFreezeActions,
          'frozen-column': shouldFreezeActions,
          'frozen-column-compact': isCompactMode
        })
      }), shouldFreezeActions && /*#__PURE__*/_react["default"].createElement("th", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: cx('freeze-column__last-column__spacer', {
          'frozen-column-compact__spacer': isCompactMode
        })
      })));
    }
  }]);

  return TableHeader;
}(_react.Component);

TableHeader.propTypes = {
  currentSort: _propTypes["default"].shape({
    direction: _propTypes["default"].oneOf([_constants.SORT_DIRECTION_ASC, _constants.SORT_DIRECTION_DESC, null]),
    field: _propTypes["default"].string
  }),
  customColumnDisplayName: _propTypes["default"].object.isRequired,
  handleSort: _propTypes["default"].func.isRequired,
  hasRowActions: _propTypes["default"].bool,
  headers: _propTypes["default"].array.isRequired,
  isCompactMode: _propTypes["default"].bool.isRequired,
  isLoading: _propTypes["default"].bool.isRequired,
  isNotSelectable: _propTypes["default"].bool.isRequired,
  rightAlignedColumns: _propTypes["default"].array,
  shouldFreezeActions: _propTypes["default"].bool.isRequired,
  // eslint-disable-line react/boolean-prop-naming
  sortableColumns: _propTypes["default"].array.isRequired
};
TableHeader.defaultProps = {
  currentSort: null,
  hasRowActions: false,
  rightAlignedColumns: []
};
var _default = TableHeader;
exports["default"] = _default;